import * as ja from '../../../../../../config/locales/js/ja.json';
angular.module('cerego.translate').constant('translateJa', ja);
